@if (!router.url.startsWith("/typage") && !router.url.startsWith("/ordine")) {
  <app-header
    [defaultLanguage]="I18NService.selectedLanguage$ | async"
    (selectedLanguageEmitter)="handleSetNewLanguage($event)"
  ></app-header>
  <!-- content goes here -->
  <div class="relative h-full w-full">
    <router-outlet></router-outlet>
    @if (showButton()) {
      <button
        pButton
        class="return-top fixed right-4 bottom-4 z-50 h-10 w-10 rounded-full sm:right-8 sm:bottom-8 sm:h-12 sm:w-12"
        icon="pi pi-chevron-up"
        (click)="scrollTop()"
      ></button>
    }
  </div>
  <app-footer></app-footer>
}
<!-- "global" come key per utilizzare al meglio il toast service -->
<p-toast key="global" [breakpoints]="toastBreakpoints" />

<p-toast
  position="bottom-center"
  key="newversion"
  [baseZIndex]="5000"
  [breakpoints]="toastBreakpoints"
>
  <ng-template let-message #headless let-closeFn="closeFn">
    <div class="flex w-full items-center justify-between p-3">
      <div class="text-md text-primary font-medium">{{ message.summary }}</div>
      <div class="shrink-0">
        <p-button
          styleClass="font-bold bg-secondary bg-on-secondary"
          severity="secondary"
          label="{{ 'checkVersion.refresh' | translate }}"
          (click)="confirmUpdate()"
        />
      </div>
    </div>
  </ng-template>
</p-toast>
